import React, { useEffect, useState, useRef } from 'react';
/* ─── STICKY BOTTOM BAR ─── */
export function StickyBottomBar() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  return null;
}
/* ─── EXIT INTENT POPUP ─── */
export function ExitIntentPopup() {
  const [show, setShow] = useState(false);
  const hasTriggered = useRef(false);
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !hasTriggered.current) {
        setShow(true);
        hasTriggered.current = true;
      }
    };
    // Mobile back button detection (simplified via history push)
    const handlePopState = () => {
      if (!hasTriggered.current) {
        setShow(true);
        hasTriggered.current = true;
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    window.addEventListener('popstate', handlePopState);
    // Push state to enable popstate detection
    window.history.pushState({
      noBackExitsApp: true
    }, '');
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  if (!show) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-id="element-366">
      <style data-id="element-367">{`
        @keyframes exit-pulse {
          0%, 100% { transform: scale(1); box-shadow: 0 0 20px rgba(230,126,34,0.4); }
          50% { transform: scale(1.02); box-shadow: 0 0 32px rgba(230,126,34,0.7), 0 0 56px rgba(230,126,34,0.3); }
        }
        .exit-pulse-btn { animation: exit-pulse 2s ease-in-out infinite; }
        @keyframes exit-pop-in {
          from { opacity: 0; transform: scale(0.92) translateY(16px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }
        .exit-pop-in { animation: exit-pop-in 0.35s ease-out forwards; }
      `}</style>
      <div className="bg-white w-full max-w-[370px] rounded-[20px] shadow-2xl relative overflow-hidden exit-pop-in" style={{
      maxHeight: '560px',
      fontFamily: "'Nunito', sans-serif"
    }} data-id="element-368">
        {/* Close button */}
        <button onClick={() => setShow(false)} className="absolute top-3 right-3 z-10 text-white/70 hover:text-white transition-colors" data-id="element-369">
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-370">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-371" />
          </svg>
        </button>

        {/* Header */}
        <div className="py-5 px-5 text-center" style={{
        background: 'linear-gradient(135deg, #2C3E50 0%, #34495e 100%)'
      }} data-id="element-372">
          <div className="bg-[#E85D4A] text-white text-[10px] font-extrabold tracking-widest uppercase py-1 px-3 rounded-full inline-block mb-2" data-id="element-373">
            ⚡ OFERTA ÚNICA
          </div>
          <h3 className="text-white text-[22px] font-extrabold leading-tight mb-1" data-id="element-374">
            🛑 ¡Esperá!
          </h3>
          <p className="text-[#5E8D5A] text-[14px] font-bold" data-id="element-375">
            ¿Segura que no querés el paquete completo?
          </p>
        </div>

        {/* Body */}
        <div className="px-5 py-4" data-id="element-376">
          {/* Discount badge */}
          <div className="text-center mb-3" data-id="element-377">
            <span className="inline-block bg-[#F5C842] text-[#2C3E50] text-[13px] font-extrabold py-1.5 px-4 rounded-full" data-id="element-378">
              🔥 30% OFF EN LOS EXTRAS
            </span>
          </div>

          {/* Single content line */}
          <p className="text-[#2C3E50] text-[14px] font-bold text-center leading-snug mb-4" data-id="element-379">
            Kit Método 3C + Jugos Camuflados + Tabla Mágica
          </p>

          {/* Price block */}
          <div className="text-center mb-5" data-id="element-380">
            <span className="text-gray-400 text-[14px] line-through mr-2" data-id="element-381">
              $19.979
            </span>
            <span className="text-[#2C3E50] text-[36px] font-extrabold leading-none block mt-1" data-id="element-382">
              $17.885
            </span>
            <p className="text-[#5E8D5A] text-[11px] font-bold mt-1" data-id="element-383">
              Precio especial solo en esta pantalla
            </p>
          </div>

          {/* Main CTA */}
          <a href="https://vitaliaguides.com/cart/46679594729649:1" className="exit-pulse-btn w-full block bg-[#E67E22] text-center rounded-2xl py-3.5 px-4 no-underline transition-colors hover:bg-[#d67118]" data-id="element-384">
            <span className="text-white text-[15px] font-extrabold block leading-snug" data-id="element-385">
              ¡SÍ! Quiero el Paquete Completo
            </span>
          </a>

          {/* Dismiss button */}
          <a href="https://vitaliaguides.com/cart/46678445981873:1" className="w-full block text-center text-gray-400 hover:text-gray-500 transition-colors no-underline mt-3" style={{
          fontSize: '14px',
          padding: '12px 0'
        }} data-id="element-386">
            No gracias, continuar sin los extras →
          </a>
        </div>
      </div>
    </div>;
}
/* ─── SOCIAL PROOF TOAST ─── */
const FIXED_NOTIFICATIONS = [{
  message: 'Sol de Córdoba acaba de comprar el Método 3C 🥦',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/4SHbQyswZxRd8H1cAZGY76/Principal_y_Bonus.png'
}, {
  message: 'Mariana de Bs. As. se sumó al Kit Maestra 🥗',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/4SHbQyswZxRd8H1cAZGY76/Principal_y_Bonus.png'
}, {
  message: 'Luz de Salta ya tiene su Guía Vitalia ✨',
  thumbnail: 'https://cdn.magicpatterns.com/uploads/4SHbQyswZxRd8H1cAZGY76/Principal_y_Bonus.png'
}];
export function SocialProofToast() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [phase, setPhase] = useState<'hidden' | 'entering' | 'visible' | 'exiting'>('hidden');
  const prefersReducedMotion = useRef(false);
  useEffect(() => {
    prefersReducedMotion.current = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }, []);
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    const showToast = () => {
      setPhase('entering');
      setTimeout(() => setPhase('visible'), prefersReducedMotion.current ? 0 : 400);
      setTimeout(() => {
        setPhase('exiting');
        setTimeout(() => {
          setPhase('hidden');
          setCurrentIndex(prev => (prev + 1) % FIXED_NOTIFICATIONS.length);
          timeoutId = setTimeout(showToast, 20000); // 20 seconds between toasts
        }, prefersReducedMotion.current ? 0 : 300);
      }, 4400);
    };
    timeoutId = setTimeout(showToast, 5000); // Initial delay
    return () => clearTimeout(timeoutId);
  }, [currentIndex]);
  if (phase === 'hidden') return null;
  const notification = FIXED_NOTIFICATIONS[currentIndex];
  const animStyle = prefersReducedMotion.current ? {} : phase === 'entering' ? {
    animation: 'toast-enter 0.4s ease forwards'
  } : phase === 'exiting' ? {
    animation: 'toast-exit 0.3s ease forwards'
  } : {};
  return <>
      <style data-id="element-387">{`
        @keyframes toast-enter {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes toast-exit {
          from { opacity: 1; transform: translateY(0); }
          to { opacity: 0; transform: translateY(20px); }
        }
      `}</style>
      <div className="fixed bottom-4 left-4 z-30" style={animStyle} data-id="element-388">
        <div className="bg-white flex items-start gap-3 p-3.5 max-w-[320px]" style={{
        borderRadius: '14px',
        boxShadow: '0 6px 24px rgba(0,0,0,0.12)',
        borderLeft: '4px solid #5E8D5A'
      }} data-id="element-389">
          <img src={notification.thumbnail} alt="Producto" className="w-10 h-10 object-cover flex-shrink-0" style={{
          borderRadius: '8px'
        }} data-id="element-390" />
          <div className="min-w-0" data-id="element-391">
            <p className="font-bold leading-tight" style={{
            color: '#2C3E50',
            fontSize: '0.85rem'
          }} data-id="element-392">
              {notification.message}
            </p>
            <p className="flex items-center gap-1 mt-1.5" style={{
            color: '#9CA3AF',
            fontSize: '0.7rem'
          }} data-id="element-393">
              <svg className="w-2.5 h-2.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-394">
                <circle cx="12" cy="12" r="10" data-id="element-395" />
                <path d="M12 6v6l4 2" data-id="element-396" />
              </svg>
              hace unos minutos
            </p>
          </div>
        </div>
      </div>
    </>;
}
/* ─── SCROLL REVEAL WRAPPER ─── */
export function ScrollReveal({
  children
}: {
  children: React.ReactNode;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-397">
      {children}
    </div>;
}